export default "__VITE_ASSET__rbST_4xl__"